var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOtherReasonIcon = function SvgOtherReasonIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "6px",
    viewBox: "0 0 16 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_icon_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-209.000000, -716.000000)",
    fill: "#20BDA3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.249976,719.000014 C219.249976,717.756273 218.243722,716.75002 216.999981,716.75002 C215.75624,716.75002 214.749986,717.756273 214.749986,719.000014 C214.749986,720.243755 215.75624,721.250009 216.999981,721.250009 C218.243722,721.250009 219.249976,720.243755 219.249976,719.000014 Z M222.499968,716.75002 C221.256227,716.75002 220.249973,717.756273 220.249973,719.000014 C220.249973,720.243755 221.256227,721.250009 222.499968,721.250009 C223.743709,721.250009 224.749962,720.243755 224.749962,719.000014 C224.749962,717.756273 223.743709,716.75002 222.499968,716.75002 Z M211.499994,716.75002 C210.256253,716.75002 209.249999,717.756273 209.249999,719.000014 C209.249999,720.243755 210.256253,721.250009 211.499994,721.250009 C212.743735,721.250009 213.749989,720.243755 213.749989,719.000014 C213.749989,717.756273 212.743735,716.75002 211.499994,716.75002 Z",
    id: "request_icon_5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOtherReasonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/other_reason_icon.e4ae17e8444fba0bf3cd20cfaa08e962.svg";